import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons/index.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours.js";
import UseHandleScroll from "../../../../hooks/useHandleScroll.js";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources.js";
import {
  addFieldForceTxnLabel,
  fieldForceTxnActionable,
  FieldForceTxnWaitingApproval,
  getSpecificfieldForceTxn,
  removeFieldForceTxnLabel,
} from "../../../../redux/features/fieldForceTransaction/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { toast } from "react-toastify";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import {
  ownerAccountsBalanceRefresh,
  setshowsuccestoast,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import { addLifeCycleStatus } from "../../../../components/CommonTimeLineCard/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import FieldForceAccountDetailsPopup from "../../../../components/_utils/FieldForceAccountDetailsPopup/index.jsx";
import FieldForceTxnDetailsPopup from "../../../../components/FieldForceTransactionComp/FieldForceTxnDetailsPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent/index.jsx";
import FieldForceTxnDeclinedPopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/FieldForceTxnDeclinedPopup.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard/index.jsx";
import CommonTransactionApprovalCard from "../../../../components/_utils/CommonTransactionApprovalCard/index.jsx";

const ApprovalGreen = ICONS.APPROVED_LINEAR;
const CloseGreyCircleIcon = ICONS.CLOSE_WITH_GREY_CIRCLE;
const QueuedIcon = ICONS.QUEUED;

const DeclinedRed = ICONS.REJECTED_RED;
const PendingIcons = ICONS.PENDING;
const FailedToAction = ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE;

const FieldForceTransactionSingleApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams(
    location?.state?.approvalStatus
      ? {
          lifecycle: location.state.approvalStatus,
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize:
            PaginationConfiguration.paginationOptions[
              GlobalConfiguration.lengthCheckZero
            ],
        }
      : {
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize:
            PaginationConfiguration.paginationOptions[
              GlobalConfiguration.lengthCheckZero
            ],
        },
  );

  const [page, setPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const labelActionDispatchedRef = useRef(false);
  const [showPopup, setShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isOutsideBankingHoursActive, setIsOutsideBankingHoursActive] =
    useState(isOutsideBankingHours());
  const [loading, setLoading] = useState({});
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [AllReimburseTxnAccounts, setAllReimburseTxnAccounts] = useState([]);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [label, setlabel] = useState(searchParam.get("category") || "");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat") || "",
  );
  const filterRef = useRef(null);
  const filterBGRef = useRef(null);
  const filterParentDivRef = useRef(null);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const cardRefs = useRef({});
  const [mainData, setMainData] = useState([]);
  const [isLabelPopupOpen, setisLabelPopupOpen] = useState(false);
  const [filteredData, setfilteredData] = useState([]);
  const [txnlabels, settxnLabels] = useState([]);
  const [labeltxnid, setLabeltxnid] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [timelineTxnDetails, setTimelineTxnDetails] = useState([]);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [toggle, setToggle] = useState(true);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);

  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [approveRejectBtnClicked, setApproveRejectBtnClicked] = useState({});
  const [labelPopupAccounts, setLabelPopupAccounts] = useState([]);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);

  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.singleReqApprovalTxnCardHeight,
  );
  const { reimbursementTxnApprovalData } = useSelector(
    (state) => state.reimbursementTransaction,
  );
  const services = useSelector((state) => state.refreshToken.services);

  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const fetchSearchDropdownData = async () => {
    setLoadingData(true);

    if (active === "Labels") {
      const available = JSON.parse(
        sessionStorage.getItem("AvailableLabelsTxnFF") || "[]",
      );

      const filtered = available.filter((l) =>
        l.toLowerCase().includes(searchUserTextDebounce.toLowerCase()),
      );

      setInputData(filtered.map((l) => ({ id: l, Label: l })));
    }

    if (active === "Category") {
      const res = await dispatch(
        getAllCategories({ search_string: searchUserTextDebounce }),
      );

      const categories = res?.payload?.categories || [];

      setInputData(
        categories.map((c) => ({
          id: c.id,
          Category: c.name,
          Description: c.description || "Not given",
        })),
      );
    }

    setLoadingData(false);
  };

  const handleClearFilters = () => {
    setCurrentCategory("");
    setDisplayCategory("");
    setLabelSearchText([]);
    setSearchUserTextDebounce("");
    setSelectedLabels([]);
    setlabel("");
    setPage(GlobalConfiguration.lengthCheckOne);
    const keepPagesize =
      searchParam.get("pagesize") ||
      PaginationConfiguration.paginationOptions[0];
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${keepPagesize}`,
      },
      { replace: true },
    );
  };

  useEffect(() => {
    if (active) fetchSearchDropdownData();
  }, [active]);

  useEffect(() => {
    onMount();
  }, [page, pageSize, currentCategory, LabelSearchText, markerData]);

  useEffect(() => {
    if (isLabelPopupOpen) {
      const availableLabels = JSON.parse(
        sessionStorage.getItem("AvailableLabelsTxnFF") || "[]",
      );
      settxnLabels(availableLabels);
    }
  }, [isLabelPopupOpen]);

  useEffect(() => {
    const updateBankingHoursStatus = () => {
      const nextStatus = isOutsideBankingHours();
      setIsOutsideBankingHoursActive((prev) =>
        prev === nextStatus ? prev : nextStatus,
      );
    };

    updateBankingHoursStatus();
    const intervalId = setInterval(
      updateBankingHoursStatus,
      IntervalConfiguration.intervalMedium,
    );

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!isOutsideBankingHoursActive) {
      setShowBanner(false);
    }
  }, [isOutsideBankingHoursActive]);

  const outsideBankingHoursLabel = getOutsideBankingHoursLabel();

  const onMount = async (isSilent) => {
    if (!isSilent) setAllBeneTxnAccountsLoading(true);

    dispatch(
      fieldForceTxnActionable({
        page_no: page,
        page_size: pageSize,
        ...(currentCategory && {
          category_id: currentCategory,
        }),
        ...(LabelSearchText && {
          labels: LabelSearchText,
        }),
      }),
    )
      .then((response) => {
        const newData = (response?.payload?.transactions || []).map(
          (account) => ({
            ...account,
            loading: false,
            error: "false",
            message: "",
            last_updated_user_id_check: "false",
            distribution_lifecycle_status: "",
          }),
        );
        setAllReimburseTxnAccounts(newData);
        setMainData(response?.payload);
        setfilteredData(response?.payload?.transactions ?? []);
        setAllBeneTxnAccountsLoading(false);
      })

      .catch(() => {
        setAllBeneTxnAccountsLoading(false);
      });
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  const handleClose = () => {
    setisLabelPopupOpen(false);
    setSelectedLabels([]);
    setLabelPopupAccounts([]);
    setLabelPopupAccounts([]);
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
    }
  };

  const handleAssignLabelsProp = async (labelsToAssign, whichToast = "new") => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      addFieldForceTxnLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    setLabelPopupLoading(false);
    if (addFieldForceTxnLabel.fulfilled.match(res)) {
      setLabelPopupAccounts((prev) =>
        prev.map((acc) => ({
          ...acc,
          labels: [...new Set([...(acc.labels || []), ...labelsToAssign])],
        })),
      );
      setSelectedLabels((prev) => [...new Set([...prev, ...labelsToAssign])]);

      onMount(true);
      toast.dismiss();
      if (whichToast === "new") {
        CommonToast({
          text: "New label assigned successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        CommonToast({
          text: "Labels assigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
      // await onMount();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    // if (addFieldForceTxnLabel.rejected.match(res)) {
    //   toast.dismiss();
    //   CommonToast({
    //     text:
    //       res?.payload?.message ||
    //       res?.error?.message ||
    //       "Something went wrong",
    //     icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
    //     variant: "var(--error)",
    //     btnProps: {
    //       isDisabled: false,
    //       enabledTextColor: "var(--text-primary)",
    //       enabledBgColor: "var(--primary-bg)",
    //     },
    //   });
    // }
    setLabelPopupLoading(false);
    return addFieldForceTxnLabel?.fulfilled?.match(res) ? true : false;
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      removeFieldForceTxnLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    setLabelPopupLoading(false);
    if (removeFieldForceTxnLabel.fulfilled.match(res)) {
      setLabelPopupAccounts((prev) =>
        prev.map((acc) => ({
          ...acc,
          labels: (acc.labels || []).filter(
            (l) => !labelsToUnassign.includes(l),
          ),
        })),
      );
      setSelectedLabels((prev) =>
        prev.filter((l) => !labelsToUnassign.includes(l)),
      );
      onMount(true);
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      // await onMount();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    // if (removeFieldForceTxnLabel.rejected.match(res)) {
    //   toast.dismiss();
    //   CommonToast({
    //     text:
    //       res?.payload?.message ||
    //       res?.error?.message ||
    //       "Something went wrong",
    //     icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
    //     variant: "var(--error)",
    //     btnProps: {
    //       isDisabled: false,
    //       enabledTextColor: "var(--text-primary)",
    //       enabledBgColor: "var(--primary-bg)",
    //     },
    //   });
    // }
    setLabelPopupLoading(false);
    return removeFieldForceTxnLabel?.fulfilled?.match(res) ? true : false;
  };

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
    setApproveRejectBtnClicked((prev) => ({
      ...prev,
      [deniedId]: "none",
    }));
  };

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handlePagination = (pageNum) => {
    setDirection("");
    handleSubmit("pageno", pageNum);
    setPage(pageNum);
  };

  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const handleRefresh = async (e, id, prevBalance) => {
    if (services?.includes("VAccountBalance")) {
      e.stopPropagation();
      try {
        let response = await dispatch(ownerAccountsBalanceRefresh(id));

        if (response?.payload?.status === true) {
          let data = AllReimburseTxnAccounts?.map((item) => {
            if (
              response?.payload.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ].owner_account_id === item.owner_account_id
            ) {
              return {
                ...item,
                owner_account_balance_last_fetched_at_in_words:
                  response.payload.owner_accounts[
                    GlobalConfiguration.lengthCheckZero
                  ].owner_account_balance_last_fetched_at_in_words,
                owner_account_balance:
                  response.payload.owner_accounts[
                    GlobalConfiguration.lengthCheckZero
                  ].owner_account_balance,

                owner_account_balance_last_fetched_at:
                  response.payload.owner_accounts[
                    GlobalConfiguration.lengthCheckZero
                  ].owner_account_balance_last_fetched_at,
              };
            }
            return item;
          });
          setAllReimburseTxnAccounts(data);
          setTimeout(() => {
            CommonToast({
              text: "Balance refreshed successfully.",
              icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
            dispatch(setshowsuccestoast());
          }, IntervalConfiguration.intervalExtraSmall);
        } else {
          setTimeout(() => {
            toast.dismiss();
            CommonToast({
              text: response?.payload?.response?.data?.errors?.base?.[0],
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
            });
          }, IntervalConfiguration.intervalMid);
        }
      } catch (error) {
        CommonToast({
          text: error,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        throw error;
      }
    } else {
      e.stopPropagation();
      navigate("/feature_not_assigned");
    }
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Transaction approved successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const SideDrawerOpen = async (id, txnId) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(true);
  };

  const updateAllTxn = (updatedTxn) => {
    setAllReimburseTxnAccounts(updatedTxn);
  };

  const handleTxnApproval = async (id) => {
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));

    CommonToast({
      text: "Approving transaction.",
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
    });

    const data = await dispatch(FieldForceTxnWaitingApproval(id));

    let errorMessage = "";
    let lifecycleStatus = "";
    let distributionStatus = "";
    if (data?.payload?.status === errorcode.errorFailed) {
      lifecycleStatus = "pending";
      CommonToast({
        text: data?.payload?.error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    if (
      data?.payload?.errors?.user_unauthorized?.[
        GlobalConfiguration.lengthCheckZero
      ]
    ) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "AFieldForceTxn",
          },
        });
      }, IntervalConfiguration.intervalExtraLarge);
    } else if (data.payload.status !== errorcode.errorNotFound) {
      const updatedData = AllReimburseTxnAccounts?.map((item) => {
        if (item.txn_id === id) {
          if (
            data.payload.status === true &&
            data.payload.transactions[GlobalConfiguration.lengthCheckZero]
              .lifecycle_status === "approved"
          ) {
            lifecycleStatus =
              data.payload.transactions[GlobalConfiguration.lengthCheckZero]
                .lifecycle_status;
            distributionStatus =
              data.payload.transactions[GlobalConfiguration.lengthCheckZero]
                .distribution_lifecycle_status;
          } else if (
            data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
              ?.errors &&
            data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
              ?.errors[GlobalConfiguration.lengthCheckZero]?.reason
          ) {
            errorMessage =
              data.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                .errors[GlobalConfiguration.lengthCheckZero].reason[
                GlobalConfiguration.lengthCheckZero
              ];
            if (
              data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
                ?.errors[GlobalConfiguration.lengthCheckZero]?.reason.length >=
              GlobalConfiguration.lengthCheckOne
            ) {
              let msgs =
                data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
                  ?.errors[GlobalConfiguration.lengthCheckZero]?.reason;
              errorMessage = msgs;

              if (data?.payload?.status === false) {
                CommonToast({
                  text: msgs,
                  icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                  variant: "var(--error)",
                  buttonNeeded: false,
                });
              }
            }
          } else if (
            data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
              ?.errors &&
            data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
              ?.errors[GlobalConfiguration.lengthCheckZero]?.reason
          ) {
            errorMessage =
              data.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                .errors[GlobalConfiguration.lengthCheckZero].reason ||
              data.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                .errors[GlobalConfiguration.lengthCheckZero].reason[
                GlobalConfiguration.lengthCheckZero
              ];
            if (
              data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
                ?.errors.length > GlobalConfiguration.lengthCheckOne
            ) {
              let msgs =
                data.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                  .errors[GlobalConfiguration.lengthCheckZero].reason;

              CommonToast({
                text: msgs,
                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }
            if (
              data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
                ?.errors.length >= GlobalConfiguration.lengthCheckOne
            ) {
              let msgs =
                data.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                  .errors[GlobalConfiguration.lengthCheckZero].reason;
              errorMessage = msgs;
            }
          } else if (
            data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
          ) {
            errorMessage =
              data.payload.errors.base[GlobalConfiguration.lengthCheckZero];
            setTimeout(() => {
              CommonToast({
                text: errorMessage,
                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, IntervalConfiguration.intervalExtraLarge);
          } else if (
            data.payload.status === true &&
            data.payload.transactions[GlobalConfiguration.lengthCheckZero]
              .lifecycle_status === "pending"
          ) {
            lifecycleStatus = "pendingOne";
          }

          return {
            ...item,
            last_updated_status:
              item.last_updated_status === "Created" &&
              data?.payload.status === true &&
              data.payload.transactions[GlobalConfiguration.lengthCheckZero]
                .last_updated_status === "Approved"
                ? "Approved"
                : "Created",

            lifecycle_status:
              data?.payload.status === true &&
              item.lifecycle_status === "pending"
                ? lifecycleStatus
                : "error",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data?.payload.status === false
                ? errorMessage
                : "",

            last_updated_user_id_check:
              item.last_updated_user_id_check === "false" &&
              data.payload.status === true &&
              loginid.employees.id ===
                data.payload.transactions[GlobalConfiguration.lengthCheckZero]
                  .last_updated_user_id
                ? "true"
                : "false",
            distribution_lifecycle_status:
              item.distribution_lifecycle_status === "" &&
              data?.payload.status === true
                ? distributionStatus
                : "",
          };
        }

        return item;
      });
      setAllReimburseTxnAccounts(updatedData);
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
      toast.dismiss();
      setApproveRejectBtnClicked({
        ...approveRejectBtnClicked,
        [id]: "none",
      });
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (
        data?.payload?.status === true &&
        data.payload.transactions[GlobalConfiguration.lengthCheckZero]
          .lifecycle_status === "approved"
      ) {
        handleApprovalToastSuccess();
      }
      if (data.payload.status === errorcode.errorNotFound) {
        CommonToast({
          text: data.payload.error,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const handleFilterCategory = () => {
    setCurrentCategory(label);
    setLabelSearchText(selectedLabels);
    setAllReimburseTxnAccounts([]);
    if (page === GlobalConfiguration.lengthCheckOne) {
      setAllBeneTxnAccountsLoading(true);
    }

    setFilterOpen(false);
  };
  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setPage(GlobalConfiguration.lengthCheckOne);
  };

  const hasAnyFilter =
    String(currentCategory ?? "").length >
      GlobalConfiguration.lengthCheckZero ||
    (LabelSearchText &&
      LabelSearchText.length > GlobalConfiguration.lengthCheckZero) ||
    (searchUserTextDebounce &&
      searchUserTextDebounce.length > GlobalConfiguration.lengthCheckZero);

  const noTransactionsFromAPI =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allBeneTxnAccountsLoading &&
    AllReimburseTxnAccounts.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && filterOpen) {
        handleFilterCategory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [label, selectedLabels, filterOpen]);

  useEffect(() => {
    const handleFilter = (e) => {
      if (
        filterBGRef.current &&
        filterBGRef.current.contains(e.target) &&
        filterParentDivRef.current &&
        !filterParentDivRef.current.contains(e.target)
      ) {
        setFilterOpen(false);
      }
    };

    document.addEventListener("click", handleFilter);

    return () => {
      document.removeEventListener("click", handleFilter);
    };
  }, [filterBGRef, filterRef]);

  useEffect(() => {
    if (label === "") {
      setCurrentCategory("");
    }
  }, [label]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, IntervalConfiguration.intervalExtraSmall);
    }
  }, [ownerAccBalanceLoading]);

  useEffect(() => {}, [reimbursementTxnApprovalData]);

  const getDistributionTitle = (status) => {
    switch (status) {
      case "distribution_complete":
        return "Distribution completed!";
      case "approved":
        return "Distribution approved";
      case "created":
        return "Distribution created";
      case "awaiting_funds":
        return "Distribution awaiting funds";
      case "distribution_pending":
        return "Distribution pending";
      case "distribution_initiated":
        return "Distribution initiated";
      case "rejected":
        return "Distribution rejected";
      case "reversal":
        return "Distribution reversal";
      case "denied":
        return "Distribution denied";
      case "abandoned":
        return "Distribution abandoned";
      case "failed":
        return "Distribution failed";
      default:
        return "Unknown error";
    }
  };

  const getDistributionSubtext = (status) => {
    switch (status) {
      case "distribution_complete":
        return "This transaction has been verified and settled.";
      case "approved":
        return "The distribution for this transaction has been approved.";
      case "created":
        return "This transaction has been approved and is sent for distribution.";
      case "awaiting_funds":
        return "This transaction has been approved and awaiting for funds.";
      case "distribution_pending":
        return "The distribution for this transaction has been pending.";
      case "distribution_initiated":
        return "This transaction has been approved and the distribution is initiated.";
      case "rejected":
        return "The distribution for this transaction has been rejected.";
      case "denied":
        return "The distribution for this transaction has been denied.";
      case "reversal":
        return "The distribution for this transaction has been reversed.";
      case "failed":
        return "The distribution for this transaction has failed.";
      default:
        return "An error occurred while taking action on this transaction.";
    }
  };

  const getDistributionIcon = (status) => {
    switch (status) {
      case "created":
      case "approved":
      case "awaiting_funds":
      case "distribution_initiated":
      case "distribution_pending":
        return QueuedIcon;

      case "distribution_complete":
        return ApprovalGreen;

      case "rejected":
      case "failed":
      case "reversal":
      case "denied":
        return DeclinedRed;

      case "abandoned":
        return CloseGreyCircleIcon;
      default:
        return null;
    }
  };

  const getTxnOverlayConfig = ({
    account,
    loading,
    openTxn,
    openAccountDrawer,
    openTxn2,
  }) => {
    const isError =
      account.lifecycle_status === "error" &&
      account.error === "true" &&
      !loading[account.txn_id];

    const isRejected =
      account.lifecycle_status === "rejected" &&
      account.error === "false" &&
      !loading[account.txn_id];

    const isAccountApprovalPending =
      account.lifecycle_status === "pending" &&
      account.field_force_account_approval_status === "pending" &&
      !loading[account.txn_id];

    const isTxnApprovalPending =
      (account.lifecycle_status === "pending" || loading[account.txn_id]) &&
      account.field_force_account_approval_status === "approved";

    const isSecondApprovalPending =
      account.last_updated_user_id_check === "true" &&
      account.lifecycle_status === "pendingOne" &&
      account.error === "false" &&
      !loading[account.txn_id];

    const hasAccountApprovalAccess = services?.includes("AFieldForceTxn");

    const isDistributionState =
      account.lifecycle_status === "approved" &&
      [
        "created",
        "approved",
        "reversal",
        "denied",
        "awaiting_funds",
        "distribution_initiated",
        "distribution_pending",
        "rejected",
        "abandoned",
        "failed",
        "distribution_complete",
      ].includes(account.distribution_lifecycle_status) &&
      account.error === "false" &&
      !loading[account.txn_id];

    if (isError) {
      return {
        cardState: "single",
        overlay1Icon: FailedToAction,
        overlay1Text: "Failed to take action!",
        overlay1Subtext: account.message,
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        overlay1Cta1Color: "var(--negative-act)",
        allowApproveReject: false,
      };
    } else if (isRejected) {
      return {
        cardState: "double",
        overlay1Icon: DeclinedRed,
        overlay1Text: "Rejected",
        overlay1Subtext: "This transaction has been rejected.",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        overlay2Text: "Rejected reason",
        overlay2Subtext: account.rejection_reason,
        allowApproveReject: false,
      };
    } else if (isAccountApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: null,
        overlay1Text: "Account approval pending",
        overlay1CtaDisabled: false,
        overlay1CtaInactive: false,
        overlay1Subtext:
          "Account is not approved, please approve account before approving transaction.",
        overlay1CtaText: "View account",
        overlay1CtaOnClick: () => {
          if (hasAccountApprovalAccess) {
            openAccountDrawer();
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "AFieldForceTxn" },
            });
          }
        },

        allowApproveReject: false,
      };
    } else if (isSecondApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: PendingIcons,
        overlay1IconColor: "var(--pending)",
        overlay1Text: "Pending",
        overlay1Subtext:
          "This transaction has been approved and requires another user's approval before distribution.",
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        allowApproveReject: false,
      };
    } else if (isDistributionState) {
      return {
        cardState: "single",
        overlay1Icon: getDistributionIcon(
          account.distribution_lifecycle_status,
        ),
        overlay1Text: getDistributionTitle(
          account.distribution_lifecycle_status,
        ),
        overlay1Subtext: getDistributionSubtext(
          account.distribution_lifecycle_status,
        ),
        overlay1CtaText: "View transaction",
        overlay1CtaOnClick: openTxn,
        allowApproveReject: false,
      };
    } else if (isTxnApprovalPending) {
      return {
        cardState: "default",
        allowApproveReject: services?.includes("AFieldForceTxn"),
      };
    } else {
      return {
        cardState: "default",
        allowApproveReject: false,
      };
    }
  };

  const PopupcloseIcons = () => {
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
    setOpenApprovalTimeline([]);
    setTimelineTxnDetails([]);

    //  setOpenTimelinePopup(false);
    //  setTimelineTxnId(null);
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const OpenTimeline = async (id) => {
    SetopenTimelinePopup(true);
    setShowApprovalTimeline(true);

    const res = await dispatch(getSpecificfieldForceTxn(id));

    if (res?.payload?.transaction) {
      const uiState = addLifeCycleStatus({
        lifecycle_status: res.payload?.transaction[0]?.lifecycle_status,
        distribution_lifecycle_status:
          res.payload?.transaction[0]?.distribution_lifecycle_status,
        services,
      });
      setTimelineTxnDetails([{ ...res.payload.transaction[0], ...uiState }]);
    }
  };
  function handleOpenBanner() {
    setShowBanner(true);
  }
  const formatAmount = (value) => {
    if (!value && value !== GlobalConfiguration.lengthCheckZero) return "";

    return Number(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <>
      {!(
        noTransactionsFromAPI ||
        noResultsAfterFilter ||
        allBeneTxnAccountsLoading
      ) && (
        <div className="fixed w-full bottom-bottom-base z-z-index-tooltip">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={mainData}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={page}
            setIsOpen={() => {}}
          />
        </div>
      )}
      {showTxnDetailPop && (
        <div
          className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneTxnDetailModal();
          }}
        >
          <FieldForceTxnDetailsPopup
            closePopup={closeBeneTxnDetailModal}
            account_txn_id={txnId}
            type={"bene_txn_detail_modal"}
            TransactionHeader={"Field force transaction details"}
            setParentTxnList={setAllReimburseTxnAccounts}
          />
        </div>
      )}

      {isDrawerOpen && (
        <div
          className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneAccountDetailModal();
          }}
        >
          <FieldForceAccountDetailsPopup
            field_force_account_id={BeneTxnDetailsId}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            setviewTxnDetails={setAllReimburseTxnAccounts}
          />
        </div>
      )}

      {isLabelPopupOpen && (
        <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={txnlabels}
            setLabels={settxnLabels}
            LabelAccounts={labeltxnid}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={labelPopupAccounts}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}

      {opentimelinepopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Field force transaction timeline"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            headertextSize="font-md"
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={PopupcloseIcons}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType="button"
            closeiconisDisabled={false}
            closeicondisabledBgColor=""
            closeiconbuttonRef={null}
            closeicontitle="Close"
            btnType="button"
            handleFunction={() => {}}
            enabledBgColor="var(--positive-act)"
            hoverOption="dark"
            outLineColor=""
            enabledTextColor="var(--text-primary)"
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor=""
            disabledBgColor=""
            isLoading={false}
            buttonRef={null}
            inActiveVariantNeeded={false}
            isLoaderNeeded={false}
            isscrollRequired={true}
          >
            <TimelinePopupContent
              logsData={timelineTxnDetails}
              showDistributionRightIcon={false}
              showApprovalLeftIcon={false}
              showApprovalTimeline={showApprovalTimeline}
              openApprovalTimeline={openApprovalTimeline}
              handleApprovalTimeline={handleApprovalTimeline}
              setOpenApprovalTimeline={setOpenApprovalTimeline}
              cardType={"double"}
              popUpMode={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showBanner && (
        <div
          className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => setShowBanner(false)}
        >
          <SmallPopupWithBulletPoints
            headerTitle={"Why transaction cannot be processed?"}
            headIconColor="var(--text-primary)"
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBanner(false)}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderFontWeight="semibold"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${outsideBankingHoursLabel} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
          />
        </div>
      )}

      {showPopup && (
        <FieldForceTxnDeclinedPopup
          handleClose={handleClosePopup}
          txnId={deniedId}
          allTxnData={AllReimburseTxnAccounts}
          updateAllTxn={updateAllTxn}
        />
      )}

      <div className="flex flex-col w-width-full h-screen bg-primary-bg pb-pagination-height">
        <div
          className={`w-width-full hidden Qsmd:block h-navbar-breadcrumb-height ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"} flex-shrink-0`}
        ></div>
        <div className="flex flex-col items-center justify-center shadow-box-shadow-bottom bg-primary-nav w-full-width z-z-index-overlay relative">
          <TopNavComponent
            direction={direction}
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={undefined}
            handleBack={() => navigate(GlobalConfiguration.navigate_back)}
            topNavCtaBtn2Needed={false}
            BottomHeader={"Post approval process"}
            BottomSubText={
              "Once approved, transaction distribution will get created and auto settled using selected source account. If there are insufficient funds, the transaction will settle once the source account is refilled, and distribution will be initiated thereafter."
            }
            isSelectionView={false}
            isToggleNeeded={true}
            toggleProps={{
              state: toggle,
              isDisabled: false,
              title: "Multi approval",
              handleClick: () =>
                navigate(
                  "/field_force_transaction_dashboard/field_force_transaction_multi_approval",
                ),
            }}
            assignLabelNeeded={false}
            assignTagNeeded={false}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: noTransactionsFromAPI
                ? true
                : allBeneTxnAccountsLoading
                  ? true
                  : false,
              onSearchInput: (val) => setSearchUserTextDebounce(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search field force transaction",
              filterPlaceholder: "Category / Labels",
              filterItems: [
                {
                  name: "Category",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    setPage(GlobalConfiguration.lengthCheckOne);
                    const categoryName =
                      inputData.find(
                        (category) => String(category?.id) === String(val),
                      )?.Category ?? "";
                    setDisplayCategory(categoryName);
                    handleSubmit("dispCat", categoryName);
                    handleSubmit("category", val);
                    setCurrentCategory(val);
                  },
                  isDropdown: true,
                  displayValue: displayCategory,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    setPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit(
                      "label",
                      Array.isArray(val) ? val.join(",") : val,
                    );
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                },
              ],
              isSearchClearAllDisabled: !(
                String(currentCategory ?? "").length || LabelSearchText?.length
              ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loadingData: loadingData,
              loading: allBeneTxnAccountsLoading,
              setLoading: setLoadingData,
              isShowSortBy: false,
              isShowFilter: false,
            }}
          />
        </div>
        <div className="flex-1 overflow-y-auto overflow-x-hidden w-width-full flex justify-center pb-padding-xl Qsmd:pb-padding-base relative">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <div
            className="flex flex-col gap-gap-md py-padding-md w-width-full px-padding-md Qlg:px-padding-base overflow-y-auto"
            onScroll={handleScroll}
          >
            {allBeneTxnAccountsLoading ? (
              <div className="w-width-full h-[calc(100vh-var(--navbar-height)-var(--pagination-height))] flex items-center justify-center">
                <Loader />
              </div>
            ) : noTransactionsFromAPI ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-md m-auto">
                <div>
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt="no_pending_transaction"
                  />
                </div>
                <p className="text-sm text-text-primary">
                  There are no more transactions that require <br /> your
                  approval.
                </p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Field force transaction dashboard"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() =>
                    navigate("/field_force_transaction_dashboard")
                  }
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-md m-auto">
                <div>
                  <img
                    src={ICONS?.NO_DATA_FOUND}
                    alt="no data found"
                  />
                </div>
                <p className="text-sm text-text-primary">No data found.</p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() => {
                    handleClearFilters();
                  }}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : (
              <>
                {isOutsideBankingHoursActive && (
                  <div className="mx-auto flex Qlg:flex-row flex-col Qlg:max-w-[var(--tab-width-normal)] w-width-full z-z-index-content">
                    <CommonAlertCard
                      title={"Functioning outside banking hours"}
                      texts={
                        <>
                          Transactions will be processed automatically during
                          the next bank working day.{" "}
                          <span
                            className="underline cursor-pointer font-semibold"
                            onClick={() => handleOpenBanner()}
                          >
                            Learn more
                          </span>
                        </>
                      }
                    />
                  </div>
                )}
                {reimbursementTxnApprovalData === undefined ||
                  AllReimburseTxnAccounts?.map((account) => {
                    const overlay = getTxnOverlayConfig({
                      account,
                      loading,
                      openTxn: () => {
                        setTxnId(account.txn_id);
                        openBeneTxnDetailModal();
                      },
                      openAccountDrawer: () =>
                        SideDrawerOpen(
                          account.field_force_account_id,
                          account.txn_id,
                        ),
                      openTxn2: () => {},
                    });

                    const alerts = [];

                    /**
                     * @type {import("../../../components/_utils/CommonTransactionApprovalCard/index.jsx").Entry[][]}
                     */
                    const entries = [
                      [
                        {
                          type: "textSubtextX2",
                          text: `INR ${formatAmount(account?.amount ?? GlobalConfiguration?.lengthCheckZero)}`,
                          subText: "Amount",
                          textColor: "settled",
                          isBold: true,
                          text1:
                            account.category_id?.category_name || "unavailable",
                          subText1: "Category",
                        },
                        {
                          type: "textSubtext",
                          text: account?.field_force_account_name
                            ?.toLowerCase()
                            ?.split(" ")
                            ?.map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                            )
                            ?.join(" "),
                          subText: "Account name",
                        },
                        {
                          type: "cta",
                          text: account?.labels?.length
                            ? account.labels.join(", ")
                            : "Not assigned",
                          subText: "Labels",
                          onClick: (e) => {
                            if (
                              services?.includes("ALabel") &&
                              services?.includes("RLabel") // <-- FIXED: Was checking ALabel twice
                            ) {
                              e.stopPropagation();
                              setLabeltxnid([account?.txn_id]);
                              setSelectedLabels(account?.labels || []);
                              // <-- ADDED THIS BLOCK (Was completely missing in Field Force):
                              setLabelPopupAccounts(
                                AllReimburseTxnAccounts.filter(
                                  (txn) => txn?.txn_id === account?.txn_id,
                                ).map((t) => ({ ...t, id: t.txn_id })),
                              );
                              setisLabelPopupOpen(true);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "ALabel,RLabel" },
                              });
                            }
                          },
                        },
                      ],
                    ];

                    return (
                      <div
                        key={account.txn_id}
                        className="mx-auto flex Qlg:flex-row flex-col Qlg:max-w-[var(--tab-width-normal)] w-width-full z-z-index-content"
                      >
                        <CommonTransactionApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={
                            approveRejectBtnClicked?.[account?.txn_id] ?? "none"
                          }
                          accountApprovalPending={
                            account.lifecycle_status === "pending" &&
                            account.field_force_account_approval_status ===
                              "pending" &&
                            !loading[account.txn_id]
                          }
                          entries={entries}
                          alerts={alerts}
                          cardState={overlay.cardState}
                          overlay1Text={overlay.overlay1Text}
                          overlay1Subtext={overlay.overlay1Subtext}
                          overlay1CtaText={overlay.overlay1CtaText}
                          overlay1CtaDisabled={false}
                          overlay1CtaOnClick={overlay.overlay1CtaOnClick}
                          overlay1Cta1Text={overlay?.overlay1Cta1Text}
                          ownerAccountNumber={account.owner_account_bank_acc_no}
                          ownerAccountIfsc={account.owner_account_ifsc_code}
                          ownerAccountNumberSubtext="Source account"
                          overlay1SubtextColor={
                            account.lifecycle_status === "pending" &&
                            account.field_force_account_approval_status ===
                              "pending" &&
                            !loading[account.txn_id]
                              ? "var(--pending)"
                              : "var(--text-primary)"
                          }
                          destinationAccountText={
                            account?.field_force_account_ifsc_code
                          }
                          destinationAccountSubtext="IFSC"
                          overlay1Cta1OnClick={overlay?.overlay1CtaOnClick}
                          overlay1Cta1Color={overlay?.overlay1Cta1Color}
                          overlay2Text={overlay.overlay2Subtext}
                          destinationAccountNumber={
                            account?.field_force_account_bank_acc_no
                          }
                          destinationAccountIfsc={
                            account?.field_force_account_ifsc_code
                          }
                          overlay2Subtext={overlay.overlay2Text}
                          approveClick={() => {
                            if (overlay.allowApproveReject) {
                              setApproveRejectBtnClicked({
                                ...approveRejectBtnClicked,
                                [account?.txn_id]: "approve",
                              });
                              handleTxnApproval(account.txn_id);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "AFieldForceTxn",
                                },
                              });
                            }
                          }}
                          rejectClick={() => {
                            if (overlay.allowApproveReject) {
                              setApproveRejectBtnClicked({
                                ...approveRejectBtnClicked,
                                [account?.txn_id]: "reject",
                              });
                              handleOpenPopup(account.txn_id);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "AFieldForceTxn",
                                },
                              });
                            }
                          }}
                          approveBtnText="Approve transaction"
                          rejectBtnText="Reject transaction"
                          ownerAccountBalance={account.owner_account_balance}
                          ownerAccountBalanceSubtext={
                            "Balance -" +
                            " " +
                            account.owner_account_balance_last_fetched_at_in_words
                          }
                          ownerAccountBalanceOnClick={(e) =>
                            handleRefresh(
                              e,
                              account.owner_account_id,
                              account.owner_account_balance,
                            )
                          }
                          ctaBtn1Text="More details"
                          ctaBtn1OnClick={() => {
                            openBeneTxnDetailModal();
                            setTxnId(account.txn_id);
                          }}
                          ctaBtn2Text="Approval history"
                          ctaBtn2OnClick={() => OpenTimeline(account.txn_id)}
                          overlay1Icon={overlay.overlay1Icon}
                          overlay1IconColor={overlay.overlay1IconColor}
                        />
                      </div>
                    );
                  })}{" "}
              </>
            )}
          </div>
        </div>
        <div
          className={`h-pagination-height ${showInnerSearchBar ? "hidden " : " hidden Qsmd:block"} w-width-full `}
        ></div>
      </div>
    </>
  );
};

export default FieldForceTransactionSingleApproval;
